import {
    GET_HIREMEMO_REQUEST, GET_HIREMEMO_SUCCESS, GET_HIREMEMO_FAIL,
    GET_HIREMEMOPDF_REQUEST, GET_HIREMEMOPDF_SUCCESS, GET_HIREMEMOPDF_FAIL,
    DELETE_HIREMEMO_REQUEST, DELETE_HIREMEMO_SUCCESS, DELETE_HIREMEMO_FAIL,
    EXPORT_HIREMEMO_REQUEST, EXPORT_HIREMEMO_SUCCESS, EXPORT_HIREMEMO_FAIL
} from "../types/hireMemoTypes";
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants'
import cogoToast from "cogo-toast";
import moment from 'moment';
import xlsx from "json-as-xlsx"

export const deleteHireMemo = (id) => async (dispatch) => {

    dispatch({ type: DELETE_HIREMEMO_REQUEST });

    try {

        const headerData = {
            "api_token": localStorage.getItem('isloggedIn'),
            "customerNo": localStorage.getItem('customerNumber'),
            "userId": localStorage.getItem('userId'),
            "billReferenceNo": id
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/delete`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: DELETE_HIREMEMO_SUCCESS, payload: data });
        window.location.reload()

    } catch (error) {
        dispatch({ type: DELETE_HIREMEMO_FAIL, payload: error.message })
    }
}


export const getHireMemo = (value, page) => async (dispatch) => {
    dispatch({ type: GET_HIREMEMO_REQUEST });

    try {
        let date = new Date();
        Date.prototype.addDays = function (n) {
            var time = this.getTime();
            var changedDate = new Date(time + (n * 24 * 60 * 60 * 1000));
            this.setTime(changedDate.getTime());
            return this;
        };


        const headerData = {
            "api_token": localStorage.getItem('isloggedIn'),
            "customerNo": localStorage.getItem('customerNumber'),
            "userId": localStorage.getItem('userId'),
            "fromDate": value != null && value.startDate ? moment(value.startDate).format('YYYY-MM-DD'): moment(date.addDays(-30)).format('YYYY-MM-DD'),
            "toDate": value != null && value.endDate ? moment(value.endDate).format('YYYY-MM-DD'): moment(new Date()).format('YYYY-MM-DD'),
            "vendorId": value ? value.transporterId : "",
            "vehicleId": value ? value.vehicleId : "",
            "hireMemoNo": value ? value.hireMemoNo : "",
            "itemsPerPage":10
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}hm/getHirememo?page=${page}`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: GET_HIREMEMO_SUCCESS, payload: data });


    } catch (error) {
        dispatch({ type: GET_HIREMEMO_FAIL, payload: error.message });
    };
};


export const generateHireMemoPDF = (id) => async (dispatch) => {
    dispatch({ type: GET_HIREMEMOPDF_REQUEST });

    try {

        const headerData = {
            "api_token": localStorage.getItem('isloggedIn'),
            "customerNo": localStorage.getItem('customerNumber'),
            "userId": localStorage.getItem('userId'),
            "hireMemoNo": id
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}hm/hmpdf`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: GET_HIREMEMOPDF_SUCCESS, payload: data });
        window.open(data)


    } catch (error) {
        dispatch({ type: GET_HIREMEMOPDF_FAIL, payload: error.message })
        cogoToast.error(error.response.data.message, { position: 'top-right' });
    };
};

export const exportHireMemo = (value, keys, cancelExportLoading) => async (dispatch) => {
    dispatch({ type: EXPORT_HIREMEMO_REQUEST });

    try {

        let date = new Date();
        Date.prototype.addDays = function (n) {
            var time = this.getTime();
            var changedDate = new Date(time + (n * 24 * 60 * 60 * 1000));
            this.setTime(changedDate.getTime());
            return this;
        };


        const headerData = {
            "api_token": localStorage.getItem('isloggedIn'),
            "customerNo": localStorage.getItem('customerNumber'),
            "userId": localStorage.getItem('userId'),
            "fromDate": value != null && value.startDate ? moment(value.startDate).format('YYYY-MM-DD'): moment(date.addDays(-30)).format('YYYY-MM-DD'),
            "toDate": value != null && value.endDate ? moment(value.endDate).format('YYYY-MM-DD'): moment(new Date()).format('YYYY-MM-DD'),
            "vendorId": value ? value.transporterId : "",
            "vehicleId": value ? value.vehicleId : "",
            "itemsPerPage":10,
            "isDataExport": 1
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}hm/getHirememo`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: EXPORT_HIREMEMO_SUCCESS, payload: data });
        if (data?.data) {
            let column_group=[]
            keys.map((element, index)=>{
                if(element && element.field !== "view"){
                    column_group.push({
                        label : element.headerName,
                        value : element.field
                    })
                }
            });

            let rowData = data?.data.map((obj)=>{
                return ({
                    hireMemoNo : obj.hireMemoNo||"",
                    hireMemoDate : obj.hireMemoDate||"",
                    vendorCode : obj.vendorDetails.vendorCode||"",
                    vendorName : obj.vendorDetails.vendorName||"",
                    vehicleNo : obj?.vehicleDetails?.vehicleNo||"",
                    vehicleType : obj.vehicleTypeDetails.vehicleType||"",
                    fromCity : obj.fromCityDetails.cityName||"",
                    toCity : obj.toCityDetails.cityName||"",
                    hireCharge : obj.hireCharge||"0",
                    tdsCharges : obj.tdsCharge||"0",
                    advanceGiven : obj.advanceGiven||"0",
                    hireMemoId : obj.id||"",
                })
            })

            let excelData = [
                {
                    sheet: "hirememo",
                    columns: column_group,
                    content: rowData
                },
            ]
            let settings = {
                fileName: "hirememo",
                writeMode: "writeFile",
            }
            const exportCallback = () => {
                cancelExportLoading();
            }

            xlsx(excelData, settings, exportCallback)
        };

    } catch (error) {
        console.log(error,'rowdata >>>> error in exporting hirememo')
        dispatch({ type: EXPORT_HIREMEMO_FAIL, payload: error.message });
    };
};

